import { useEffect } from "react";
import styled from "styled-components";
import TableView, {
  ColumnConfig,
  FetchParams,
} from "../../../components/controls/table-view";
import {
  ProductContainer,
  ProductImage,
  ProductNameContainer,
  ProductTitle,
} from "../../../styles/shared/product";
import {
  GoogleIcon,
  ICON_ID,
  ICON_SIZES,
} from "../../../components/icons/google-icon";
import Image from "../../../components/controls/image";
import {
  fetchSupplierProducts,
  resetSearchProducts,
  resetSupplierProducts,
  resetUnmappedSelectedProduct,
  setUnmappedSelectedProduct,
} from "../../../store/features/supplier/supplier-product-slice";
import Button from "../../../components/controls/button";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import {
  SmallTextContainer,
  TextContainer,
} from "../../../styles/shared/table";
import { ApplicationSupplierProductHeader } from "../../../models/supplier/application-supplier-product-header";
import { openDrawer } from "../../../store/features/drawer/drawer-slice";
import { DrawerID } from "../../../constants/drawer-constants";
interface MapProductsProps {
  supplierId: number;
}
export default function MapProducts({ supplierId }: MapProductsProps) {
  const products = useAppSelector((state) => state.supplierProducts);

  const dispatch = useAppDispatch();
  const columnConfig: { [key: string]: ColumnConfig } = {
    id: {
      hidden: true,
    },
    productId: {
      hidden: true,
    },
    supplierId: {
      hidden: true,
    },
    description: {
      hidden: true,
    },
    image: {
      hidden: true,
    },
    newPrice: {
      hidden: true,
    },
    editPrice: {
      hidden: true,
    },
    price: {
      hidden: true,
    },
    supplierName: {
      hidden: true,
    },
    updated: {
      hidden: true,
    },
    active: {
      hidden: true,
    },
    plu: {
      hidden: true,
    },
    sizeUnit: {
      hidden: true
    },
    reference: {
      hidden: true
    },
    openPricing: {
      hidden: true
    },
    information: {
      hidden: true
    },
    className: {
      hidden: true
    },
    hasHistory: {
      hidden: true
    },
    deliveryDay: {
      hidden: true
    },
    productOverride: {
      hidden: true
    },
    name: {
      name: "Product",
      order: 1,
      colspan: 2,
      render: (value: string, row: any) => (
        <ProductContainer>
          <ProductImage>
            {row.productId ? (
              <Image image={row.image}></Image>
            ) : (
              <GoogleIcon
                tooltip="Not mapped"
                id={ICON_ID.QuestionMark}
                isWarning
                size={ICON_SIZES.Large}
              />
            )}
          </ProductImage>
          <ProductNameContainer>
            <ProductTitle>{value} {row.reference ? ` - (${row.reference})` : ""}</ProductTitle>
            <SmallTextContainer> Plu: {row.plu}</SmallTextContainer>
          </ProductNameContainer>
        </ProductContainer>
      ),
    },
    size: {
      render: (value: string, row: any) => <TextContainer>{value} {row.sizeUnit}</TextContainer>,
    },
  };

  useEffect(() => {
    dispatch(resetUnmappedSelectedProduct());
    fetchMoreData({
      reset: true
    });
    return () => {
      dispatch(resetSupplierProducts());
    };
  }, []);

  const fetchMoreData = async (fetchParams: FetchParams) => {
    await dispatch(fetchSupplierProducts({ supplierId, unmappedOnly: true, fetchParams }));
  };

  const renderActionButton = (row: any) => (
    <Button
      variant="text"
      icon={ICON_ID.ChevronRight}
      id={`btnSelect${row.name}`}
      label=""
      isSecondary={true}
      fullWidth={false}
      onClick={() => onSelected(row)}
    />
  );

  const onSelected = async (row: any) => {
    dispatch(
      setUnmappedSelectedProduct(row as ApplicationSupplierProductHeader)
    );
    dispatch(
      openDrawer({
        id: DrawerID.MapProduct,
        anchor: "right",
        data: {
          headerText: `Map ${row?.name}`,
          supplierId: supplierId,
        },
      })
    );
    dispatch(resetSearchProducts());
  };

  return (
    <Container>
      <TableView
        id="tblProducts"
        emptyText="No products"
        fetchData={(search) => fetchMoreData(search)}
        preLoadedData={true}
        onRowClick={onSelected}
        totalCount={products.products?.count ?? 0}
        data={products?.products?.products ?? []}
        columnConfig={columnConfig}
        actionButton={renderActionButton}
        showHeaders={true}
        search
      />
    </Container>
  );
}

const Container = styled.div`
  min-height: 0;
`;
